module.exports = __webpack_public_path__ + "img/people-1.2cdfd5d9.jpg";